/* eslint-disable @next/next/no-img-element */
// @ts-nocheck
import React, { useState } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { icon_list } from '@/assets/images';
import Image from 'next/image';

type MenuType = {
  children: React.ReactNode;
  className: string;
}
const Menu = (props:MenuType) => {
  const shadow = 'hsla(218, 50%, 10%, 0.1)';
  return (
    <div
      style={{
        // backgroundColor: 'white',
        borderRadius: 4,
        // boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: 'absolute',
        zIndex: 5,
        width: '100%',
      }}
      {...props}
    />
  );
};

type DropdownType = {
  children: React.ReactNode;
  isOpen: boolean;
  target: React.ReactNode;
  onClose?: () => void;
  value: any;
}
const Dropdown = ({ children, isOpen, target, onClose, value }: DropdownType) => (
  <div className='tw-w-full tw-relative tw-border-[1px] tw-border-dark-green tw-rounded-full tw-bg-white'>
    {target}
    {isOpen ? <Menu className={`${_.isEmpty(value) ? 'empty-menu' : 'selected-menu'}`}>{children}</Menu> : null}
    {/* {isOpen ? <div className='top-0 left0 fixed z-[1]' onClick={onClose} /> : null} */}
  </div>
); 

const selectStyles = {
  control: (provided:any) => ({ ...provided, minWidth: 240, margin: 8 }),
  menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
};

type InputSelectType = {
  data: {
    placeholder: string;
    type?: string;
    value: {label: string} | string;
    name: string;
    title: string;
    options?: any;
    onSelectSearch?: (inputValue: string, callback: (options: any) => void) => void;
    disabled?: boolean;
  },
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const InputSelect = ({data, onChange}: any) => {
  const [inputValue, setInputValue] = useState('')
  const [isOpen, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!isOpen)
  }

  const onSelectChange = (value:any) => {
    const event = {type: 'select', name: data.name}
    onChange({...value, target: event})
    toggleOpen()
  };

  const [timerID, setTimerID] = useState<any>(0);
  const handleDynamicLoad = (inputValue:any, callback:any) => {
    clearTimeout(timerID);
    const timer = setTimeout(() => data.onSelectSearch(inputValue, callback), 1000);
    setTimerID(timer)    
  }
  return (
    <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <button
          disabled={data.disabled}
          onClick={toggleOpen}
          className='tw-w-full tw-text-left tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-between disabled:tw-bg-[#d1d1d16b]'
        >

          <span className={`${data.value ? 'tw-text-black' : 'tw-text-[#AAAAAA]'} tw-capitalize tw-truncate `}>{data.value ? data.value.label : data.placeholder}</span>
          <Image src={icon_list.chevron_down_gray} alt='' />
        </button>
      }
      value={data.value}
    >
      {data.onSelectSearch ? (
        <AsyncSelect
          cacheOptions
          loadOptions={handleDynamicLoad}
          inputValue={inputValue}
          onInputChange={e => setInputValue(e)}
          onChange={onSelectChange}
          autoFocus
          menuIsOpen
          defaultOptions
          value={data.value}
          placeholder={
            <div className='tw-flex tw-items-center'>
              <img src={icon_list.search_gray} alt='' className='tw-w-[15px]' />
              <span className='tw-ml-1'>Type to Search {data.title}</span>
            </div>
          }
          onBlur={toggleOpen}
        />
      ) : (
        <Select
          autoFocus
          backspaceRemovesValue={false}
          components={{ IndicatorSeparator: null, DropdownIndicator: null }}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          isClearable={false}
          menuIsOpen
          onChange={onSelectChange}
          options={data.options}
          placeholder={
            <div className='tw-flex tw-items-center'>
              <Image src={icon_list.search_gray} alt='' className='tw-w-[15px]' />
              <span className='tw-ml-1'>Search {data.title}</span>
            </div>
          }
          // styles={selectStyles}
          className='custom-select tw-text-left'
          tabSelectsValue={false}
          value={data.value}
          onBlur={toggleOpen}
        />
      )}
    </Dropdown>
  );
}

InputSelect.propTypes = {
  data: PropTypes.object,
};

InputSelect.defaultProps = {
  data: {
    title: '',
    placeholder: '',
    type: '',
    onChange: () => {},
    value: null,
    options: [
      { value: '', label: '' }
    ],
    onSelectSearch: null // for async process
  }
};

export default InputSelect;
